import Vue from 'vue'
import Router from 'vue-router'
import Start from './views/Start.vue'
import OrderInformation from './components/Order.vue'
import DebtorInformation from './components/Debtors.vue'
import BillInformation from './components/Bills.vue'
import ClientInformation from './views/ClientInformation.vue'
import MoneyLaundering from './views/MoneyLaundering.vue'
import DigitalSigning from './views/DigitalSigning.vue'
import RegistrationComplete from './views/RegistrationComplete.vue'

import AuthGuard from './plugins/auth-guard'
import goTo from 'vuetify/lib/services/goto'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'start',
      component: Start,
      meta: {
        step: 1
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/order',
      name: 'order',
      component: OrderInformation,
      meta: {
        step: 2
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/order/debtor',
      name: 'debtor',
      component: DebtorInformation,
      meta: {
        step: 2
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/order/bill',
      name: 'bill',
      component: BillInformation,
      meta: {
        step: 2
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/basic-information',
      name: 'information',
      component: ClientInformation,
      meta: {
        step: 3
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/money-laundering',
      name: 'money',
      component: MoneyLaundering,
      meta: {
        step: 4
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/digital-signing',
      name: 'signing',
      component: DigitalSigning,
      meta: {
        step: 5
      },
      beforeEnter: AuthGuard
    },
    {
      path: '/registration-complete',
      name: 'final',
      props: route => ({ requestId: route.query.requestId, taskId: route.query.taskId }),
      component: RegistrationComplete
    }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  }
})
